import { IValueModelReadonly } from '@zajno/common/models/types';
import { reaction } from 'mobx';
import { useLayoutEffect, useState } from 'react';

export function useFlagModel(model: IValueModelReadonly<boolean>) {
    const [ isActive, setIsActive ] = useState(model.value);

    useLayoutEffect(() => {
        return reaction(
            () => model.value,
            setIsActive,
            { fireImmediately: true },
        );
    }, [model]);

    return isActive;
}
